import React, { useEffect } from "react";

import { hooks } from "../hooks";
import { screens } from "../screens";
import { TABS } from "../constants/app_routes";
import { useQueryCountMyTrades } from "../graphql/apollo/useQuery";

export const TabNavigator: React.FC = () => {
  const screen = hooks.useAppSelector((state) => state.tabSlice.screen);
  const { refetch: refetchCount } = useQueryCountMyTrades();

  useEffect(() => {
    const interval = setInterval(() => {
      refetchCount();
    }, 30000); // 30 seconds

    return () => clearInterval(interval);
  }, [refetchCount]);

  return (
    <>
      {screen === TABS.Home && <screens.Home />}
      {screen === TABS.MY_TRADES && <screens.MyTrades />}
      {screen === TABS.PROFILE && <screens.ProfileScreen />}
    </>
  );
};
